var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import UserService from '../../api/UserService';
import { Loading } from 'element-ui';
import AddDialog from './AddDialog.vue';
import TransferDialog from './TransferDialog.vue';
import { UrlHelper } from '../../helper/UrlWrapper';
import Record from './Record.vue';
import { mapGetters, mapActions } from 'vuex';
import GlobalVue from "../../globalVue";
import Auth from './Auth.vue';
import AddStore from "./components/AddStore.vue";
import BindStoreDetail from "./BindStoreDetail.vue";
import PowerAuthManageList from '../powerAuthManage/List.vue';
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isShowStore = false;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 300;
        _this.searchText = '';
        _this.rowData = null;
        _this.dialogTableVisible = false;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.responseFail = false;
        _this.responseSuccess = false;
        _this.errorMsg = "";
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.createRole = [];
        _this.failDownLoadUrl = "";
        _this.business_data_power = false;
        _this.depot_data_power = false;
        _this.business_data_power_use = 1;
        return _this;
    }
    List.prototype.created = function () {
        this.service = UserService.getInstance();
    };
    List.prototype.mounted = function () {
        var _this = this;
        this.getLists();
        this.getAuth();
        this.initStoreAuth();
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = document.documentElement.clientHeight - 210;
            }
        }, 300);
    };
    List.prototype.initStoreAuth = function () {
        var _this = this;
        this.getPageAuth('210013').then(function (pageAuth) {
            _this.isShowStore = pageAuth && pageAuth.Auth && pageAuth.Auth.LookDetail;
        });
    };
    List.prototype.getAuth = function () {
        var _this = this;
        this.service.getSupplierConfigdetail().then(function (res) {
            if (res.data && res.data.success) {
                var systemSetting = res.data.data;
                _this.business_data_power = systemSetting.business_data_power_status == 1 ? true : false;
                _this.depot_data_power = systemSetting.depot_data_power_status == 1 ? true : false;
                _this.business_data_power_use = systemSetting.business_data_power_use || 1;
            }
        });
    };
    List.prototype.getLists = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var params = { keyword: this.searchText };
        Object.assign(params, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getUserListData(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                _this.listData = res.data.data;
                _this.total = res.data.total;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    List.prototype.exportIn = function () {
        this.dialogTableVisible = true;
        this.setUploadType("beford");
    };
    List.prototype.addAccount = function () {
        var _this = this;
        var instance = this.$dialog(AddDialog, {
            data: {
                isEdit: false
            }
        }, {
            title: "添加账号",
            width: 600,
            height: 520
        }).instance;
        instance.$on('save:ok', function () {
            window._czc.push(["_trackEvent", '用户列表', '添加账号']);
            _this.getLists();
        });
    };
    List.prototype.transferAuth = function () {
        var instance = this.$dialog(TransferDialog, {
            $store: this.$store
        }, {
            title: "转移权限",
            height: 500,
            width: 700,
        }).instance;
    };
    List.prototype.search = function () {
        this.$refs.pagination.clear();
        this.getLists();
    };
    List.prototype.pageChange = function () {
        this.getLists();
    };
    List.prototype.edit = function (row) {
        var _this = this;
        var instance = this.$dialog(AddDialog, {
            data: {
                isEdit: true,
                rowData: row
            }
        }, {
            title: "编辑账号",
            width: 600,
            height: 420
        }).instance;
        instance.$on('edit:ok', function () {
            window._czc.push(["_trackEvent", '用户列表', '编辑账号']);
            _this.getLists();
        });
    };
    List.prototype.lookDetail = function (row) {
        GlobalVue.$emit("addTab", {
            component: Record,
            title: "操作记录",
            name: "record_" + row.account_id,
            showExist: true,
            cprops: {
                row: row
            }
        });
        window._czc.push(["_trackEvent", '用户列表', '查看操作记录']);
    };
    List.prototype.lookStore = function (row, power) {
        var newRow = row;
        newRow.power = power;
        GlobalVue.$emit('addTab', {
            component: BindStoreDetail,
            title: '查看绑定门店',
            showExist: false,
            name: 'bind-store-detail',
            cprops: {
                rowData: newRow
            },
        });
    };
    List.prototype.setAuth = function (row) {
        sessionStorage.setItem("clickRoleId", JSON.stringify(row));
        this.rowData = row;
        this.$refs.auth.showRelease();
    };
    List.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    List.prototype.getSelectIds = function () {
        var account_ids = this.selectRows.map(function (item) { return item.account_id; });
        return account_ids;
    };
    List.prototype.bindStore = function (row) {
        var _this = this;
        if (row == 2) {
            if (!this.selectRows || !this.selectRows.length) {
                this.$message.error('请先选择用户！');
                return true;
            }
        }
        var account_ids = row && row.account_id ? row.account_id : this.getSelectIds();
        var dialog = this.$dialog(AddStore, {
            data: {
                account_id: account_ids
            }
        }, {
            title: "选择门店",
            width: 950,
            height: 500
        });
        dialog.instance.$on("save:ok", function (res) {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                account_ids: res.account.toString(),
                shop_ids: res.data.toString()
            };
            _this.service.bindUsertoStore(params).then(function (res) {
                loadingInstance.close();
                _this.$message.success('操作成功');
                _this.getLists();
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
                loadingInstance.close();
            });
            dialog.instance.close();
        });
    };
    List.prototype.delAccount = function (row) {
        var _this = this;
        var tpl = "注销后，该账号将彻底删除无法使用，请确认是否注销";
        this.$confirm(tpl, '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                var params = {
                    account_id: row.account_id,
                };
                _this.service.destoryAccount(params).then(function (res) {
                    _this.$message.success(res.data.msg || "操作成功");
                    _this.getLists();
                    window._czc.push(["_trackEvent", '用户列表', '停用']);
                }).catch(function (err) {
                    _this.$message.error(err.message);
                });
            }
        }).catch(function () {
        });
    };
    List.prototype.setStatus = function (row) {
        var _this = this;
        var title = row.account_status == 1 ? '停用后，该账号将无法使用，请确认是否停用。' : '启用后，该账号可正常使用，请确认是否启用。';
        this.$confirm(title, '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                var params = {
                    account_id: row.account_id,
                    account_status: row.account_status == 1 ? 0 : 1,
                };
                _this.service.disEnable(params).then(function (res) {
                    _this.$message.success(res.data.msg || "操作成功");
                    _this.getLists();
                    if (row.account_status == 1) {
                        window._czc.push(["_trackEvent", '用户列表', '停用']);
                    }
                    else {
                        window._czc.push(["_trackEvent", '用户列表', '启用']);
                    }
                }).catch(function (err) {
                    _this.$message.error(err.message);
                });
            }
        }).catch(function () {
        });
    };
    List.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "xlsx" || fileType == "xls"))) {
            this.$message.error("文件只能是xlsx或xls");
            return false;
        }
        ;
        if (!this.loadingInstance)
            this.loadingInstance = Loading.service({ fullscreen: true });
    };
    List.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_num;
            this.importFailnum = data.error_num;
            this.createRole = data.not_exists_role;
            var url = "/basicapi/export_error?import_id=" + data.import_id + '&type=' + data.type;
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            this.getLists();
            window._czc.push(["_trackEvent", '用户管理', '导入用户']);
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    List.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    List.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    List.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    List.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    List.prototype.toPowerAuth = function () {
        this.dialogTableVisible = false;
        GlobalVue.$emit("addTab", {
            component: PowerAuthManageList,
            title: "岗位权限管理",
            name: 444,
            showExist: true,
        });
    };
    List = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
            components: {
                'auth': Auth,
            },
            methods: __assign({}, mapActions({
                'getPageAuth': 'getAuth'
            }))
        })
    ], List);
    return List;
}(Vue));
export default List;
